"use client"

import type { FunctionComponent } from "react"

import { Loader } from "@jobteaser/spark/components/Icons/Loader"
import { Link } from "@jobteaser/spark/components/Link"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"
import { ApprovalPageContent } from "@/modules/termsAndConditions/ApprovalPage/ApprovalPageContent"

import styles from "./ApprovalPage.module.css"

export const ApprovalPage: FunctionComponent = () => {
  const locale = useLocale()
  const { t, tReact, ready } = useTranslation(["terms_and_conditions"], true)

  if (!ready)
    return (
      <main className={styles.loader}>
        <Loader />
      </main>
    )

  const generalTermsLink = (
    <Link
      href={`/${locale}/about/terms-for-members`}
      target="_blank"
      variant="body2"
      rel="noopener noreferrer"
      title=""
    >
      {t("terms_and_conditions.approval.general_terms_link")}
    </Link>
  )

  const privacyPolicyLink = (
    <Link href={`/${locale}/about/privacy-policy`} target="_blank" variant="body2" rel="noopener noreferrer" title="">
      {t("terms_and_conditions.approval.privacy_policy_link")}
    </Link>
  )

  return (
    <ApprovalPageContent
      title={t("terms_and_conditions.approval.title")}
      explanation={t("terms_and_conditions.approval.explanation")}
      text={tReact("terms_and_conditions.approval.text", {
        general_terms_link: generalTermsLink,
        privacy_policy_link: privacyPolicyLink,
      })}
      validate={t("terms_and_conditions.approval.validate")}
    />
  )
}
